/* import __COLOCATED_TEMPLATE__ from './lose-access-modal.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tagName } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import Component from '@ember/component';
import { getRetailPlanToken, PAID_RESTAURANTS_VERTICALS, RETAIL_REPRICING_2023_PLAN_TOKEN, Vertical } from '@dashboard/shared-ui/utils/vertical-configs';
import { localeForConfig } from '@dashboard/shared-ui/utils/rst-upsell-config';
import { AllDevicesImageConfig, RstMobileForDashboardImageConfig } from '@dashboard/shared-ui/utils/rst-all-devices-config';
import * as modalEvents from '@dashboard/shared-ui/events/lose-access-modal/event-catalog';
import allowDeprecatedOverrides from '@square/dashboard-utilities/utils/compat/allow-deprecated-overrides';
import { dependentKeyCompat } from '@ember/object/compat';
import { SUBSCRIPTIONS_UJ_NAMES } from '@dashboard/user-journeys/utils/subscriptions-user-journey-constants';
import { UJ_OUTCOME } from '@dashboard/user-journeys/utils/user-journey-constants';
/**

## Modals::LoseAccessModal

For Retail Plus and Restaurants Plus, when you cancel the subscription we show this
modal to highlight the features that you're going to lose if you follow through and downgrade
to the corresponding free plan.

@param {Action} [close] Closes the modal (via the Modal Service)
@param {Vertical} [modalOptions.vertical] The vertical that is being downgraded from.
                                          Verticals are defined in @dashboard/shared-ui/utils/vertical-configs.
@param {string} [continueButtonLabel] Optionally provided to override the text of the primary button
@param {string} [keepServiceButtonLabel] Optionally provided to override the text of the secondary button
*/
let LoseAccessModal = (_dec = tagName(''), _dec2 = readOnly('modalOptions.vertical'), _dec3 = computed('vertical'), _dec4 = computed('vertical'), _dec5 = computed('i18n', 'vertical'), _dec6 = computed('userInfo.{browserLanguage,countryCode}', 'vertical'), _dec7 = computed('i18n', 'vertical'), _dec8 = computed('i18n', 'vertical'), _dec9 = computed('features', 'i18n', 'modalOptions', 'userInfo.countryCode', 'vertical'), _dec(_class = (_class2 = class LoseAccessModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "assetMap", _descriptor, this);
    _initializerDefineProperty(this, "i18n", _descriptor2, this);
    _initializerDefineProperty(this, "userInfo", _descriptor3, this);
    _initializerDefineProperty(this, "features", _descriptor4, this);
    _initializerDefineProperty(this, "eventstream", _descriptor5, this);
    _initializerDefineProperty(this, "userSubscriptions", _descriptor6, this);
    _initializerDefineProperty(this, "userJourney", _descriptor7, this);
    _initializerDefineProperty(this, "vertical", _descriptor8, this);
  }
  get verticalClassName() {
    switch (this.vertical) {
      case Vertical.RESTAURANTS:
      case Vertical.RESTAURANTS_PRO:
        return 'lose-access-modal--vertical-rst';
      case Vertical.RETAIL:
        return 'lose-access-modal--vertical-rtl';
      default:
        return '';
    }
  }
  get isRestaurants() {
    return PAID_RESTAURANTS_VERTICALS.includes(this.vertical);
  }
  get modalTitle() {
    switch (this.vertical) {
      case Vertical.RESTAURANTS:
      case Vertical.RESTAURANTS_PRO:
        return this.i18n.t('sharedUi.modals.loseAccessModal.title.restaurants');
      case Vertical.RETAIL:
        return this.i18n.t('sharedUi.modals.loseAccessModal.title.retail');
      default:
        return '';
    }
  }
  get heroImage() {
    const locale = this.userInfo.browserLanguage;
    const showUSHardwareLockupImage = localeForConfig(this.userInfo.countryCode, this.userInfo.browserLanguage) === 'US';
    switch (this.vertical) {
      case Vertical.RESTAURANTS:
      case Vertical.RESTAURANTS_PRO:
        return {
          description: this.i18n.t('sharedUi.images.restaurants.allDevices.hero.description'),
          responsiveImageSource: showUSHardwareLockupImage ? RstMobileForDashboardImageConfig : AllDevicesImageConfig[localeForConfig(this.userInfo.countryCode, this.userInfo.browserLanguage)]['src'],
          height: 222,
          width: 545
        };
      case Vertical.RETAIL:
        return {
          description: this.i18n.t('sharedUi.modals.loseAccessModal.hero.description.retail'),
          responsiveImageSource: {
            '1x': this.assetMap.resolve(`/@dashboard/shared-ui/images/rtl/rtl-lose-access-modal-hero-${locale}@1x.png`),
            '2x': this.assetMap.resolve(`/@dashboard/shared-ui/images/rtl/rtl-lose-access-modal-hero-${locale}@2x.png`)
          },
          height: 275,
          width: 395
        };
      default:
        return null;
    }
  }
  get bodyTitle() {
    switch (this.vertical) {
      case Vertical.RESTAURANTS:
      case Vertical.RESTAURANTS_PRO:
        return this.i18n.t('sharedUi.modals.loseAccessModal.bodyTitle.restaurants');
      case Vertical.RETAIL:
        return this.i18n.t('sharedUi.modals.loseAccessModal.bodyTitle.retail');
      default:
        return '';
    }
  }
  get bodySubtitle() {
    switch (this.vertical) {
      case Vertical.RESTAURANTS:
      case Vertical.RESTAURANTS_PRO:
        return this.i18n.t('sharedUi.modals.loseAccessModal.bodySubtitle.restaurants');
      case Vertical.RETAIL:
        return this.i18n.t('sharedUi.modals.loseAccessModal.bodySubtitle.retail');
      default:
        return '';
    }
  }
  get lostFeatureNames() {
    switch (this.vertical) {
      case Vertical.RESTAURANTS:
      case Vertical.RESTAURANTS_PRO:
        return [this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.restaurants.restaurantsMobile'), this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.restaurants.advancedSupport'), this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.restaurants.unlimitedTeamManagement'), this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.restaurants.advancedReporting'), this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.restaurants.unlimitedKDS'), this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.restaurants.advancedPOSFeatures')];
      case Vertical.RETAIL:
        {
          // we want a different copy for the team management feature, in case
          // if retail repricing is enabled for the user, and they have the new plan
          const planToken = getRetailPlanToken(this.features, this.userSubscriptions);
          let teamManagementFeature = this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.retail.unlimitedTeamManagement');
          if (planToken === RETAIL_REPRICING_2023_PLAN_TOKEN) {
            teamManagementFeature = this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.retail.unlimitedTeamTracking');
          }
          if (this.userInfo.countryCode === 'AU') {
            return [this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.retail.inventoryManagement'), teamManagementFeature, this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.retail.advancedReporting'), this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.retail.barCodePrinting')];
          }
          return [this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.retail.reducedProcessingFee'), this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.retail.inventoryManagement'), teamManagementFeature, this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.retail.advancedReporting'), this.i18n.t('sharedUi.modals.loseAccessModal.lostFeatures.retail.barCodePrinting')];
        }
      default:
        return [];
    }
  }

  // Defined here, but can be overridden
  get continueButtonLabel() {
    return this.i18n.t('button.continue');
  }

  // Defined here, but can be overridden
  get keepServiceButtonLabel() {
    // Translations are named "dismissButton" due to previous naming scheme and were
    // not changed to save from having to retranslate them.
    switch (this.vertical) {
      case Vertical.RESTAURANTS:
      case Vertical.RESTAURANTS_PRO:
        return this.i18n.t('sharedUi.modals.loseAccessModal.footer.dismissButton.restaurants');
      case Vertical.RETAIL:
        return this.i18n.t('sharedUi.modals.loseAccessModal.footer.dismissButton.retail');
      default:
        return '';
    }
  }
  didInsertElement(...args) {
    super.didInsertElement(...args);
    this.eventstream.track(modalEvents.modalShown(this.vertical));

    // Start user journey tracking for Retail only; other verticals use different modals/flows
    if (this.vertical === Vertical.RETAIL) {
      const planToken = getRetailPlanToken(this.features, this.userSubscriptions);
      this.userJourney.startIfNotStarted(SUBSCRIPTIONS_UJ_NAMES.VIEW_FEATURE_LOSS_ON_DOWNGRADE, planToken);
    }

    // Sets the behavior for clicking outside of the modal.
    this.setCloseHandler(() => {
      this.eventstream.track(modalEvents.modalClosed(this.vertical));
      // Other verticals use different modals/flows
      if (this.vertical === Vertical.RETAIL) {
        this.userJourney.endIfNotEnded(SUBSCRIPTIONS_UJ_NAMES.VIEW_FEATURE_LOSS_ON_DOWNGRADE, UJ_OUTCOME.USER_CANCELED);
      }
      return {
        didDismiss: true
      };
    });
  }
  dismiss() {
    this.eventstream.track(modalEvents.modalClosed(this.vertical));
    // Other verticals use different modals/flows
    if (this.vertical === Vertical.RETAIL) {
      this.userJourney.endIfNotEnded(SUBSCRIPTIONS_UJ_NAMES.VIEW_FEATURE_LOSS_ON_DOWNGRADE, UJ_OUTCOME.USER_CANCELED);
    }
    this.close({
      didDismiss: true
    });
  }
  continue() {
    this.eventstream.track(modalEvents.confirmed(this.vertical));
    // Other verticals use different modals/flows
    if (this.vertical === Vertical.RETAIL) {
      this.userJourney.endIfNotEnded(SUBSCRIPTIONS_UJ_NAMES.VIEW_FEATURE_LOSS_ON_DOWNGRADE, UJ_OUTCOME.SUCCEEDED);
    }
    this.close({
      didContinue: true
    });
  }
  keepService() {
    this.eventstream.track(modalEvents.keptService(this.vertical));
    // Other verticals use different modals/flows
    if (this.vertical === Vertical.RETAIL) {
      this.userJourney.endIfNotEnded(SUBSCRIPTIONS_UJ_NAMES.VIEW_FEATURE_LOSS_ON_DOWNGRADE, UJ_OUTCOME.USER_CANCELED);
    }
    this.close({
      didKeepService: true
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "eventstream", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "userSubscriptions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "userJourney", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "vertical", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "verticalClassName", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "verticalClassName"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isRestaurants", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "isRestaurants"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "modalTitle", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "modalTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "heroImage", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "heroImage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "bodyTitle", [_dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "bodyTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "bodySubtitle", [_dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "bodySubtitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "lostFeatureNames", [_dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "lostFeatureNames"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "continueButtonLabel", [dependentKeyCompat, allowDeprecatedOverrides], Object.getOwnPropertyDescriptor(_class2.prototype, "continueButtonLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "keepServiceButtonLabel", [dependentKeyCompat, allowDeprecatedOverrides], Object.getOwnPropertyDescriptor(_class2.prototype, "keepServiceButtonLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dismiss", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "dismiss"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "continue", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "continue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "keepService", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "keepService"), _class2.prototype), _class2)) || _class);
export { LoseAccessModal as default };